export const TEST_ID = 'BaseCheckbox'
